import {
  CREATE_DISCOUNT_FAILURE,
  CREATE_DISCOUNT_REQUEST,
  CREATE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAILURE,
  DELETE_DISCOUNT_REQUEST,
  DELETE_DISCOUNT_SUCCESS,
  FETCH_DISCOUNT_FAILURE,
  FETCH_DISCOUNT_REQUEST,
  FETCH_DISCOUNT_SUCCESS,
  FETCH_DISCOUNTS_FAILURE,
  FETCH_DISCOUNTS_REQUEST,
  FETCH_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNT_COUPONS_FAILURE,
  FETCH_DISCOUNT_COUPONS_REQUEST,
  FETCH_DISCOUNT_COUPONS_SUCCESS,
  GENERATE_DISCOUNT_COUPONS_FAILURE,
  GENERATE_DISCOUNT_COUPONS_REQUEST,
  GENERATE_DISCOUNT_COUPONS_SUCCESS,
  MARK_DISCOUNT_COUPONS_PRINTED_FAILURE,
  MARK_DISCOUNT_COUPONS_PRINTED_REQUEST,
  MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS,
  MARK_DISCOUNT_COUPONS_USED_FAILURE,
  MARK_DISCOUNT_COUPONS_USED_REQUEST,
  MARK_DISCOUNT_COUPONS_USED_SUCCESS,
  RESET_DISCOUNT_FILTERS,
  SET_DISCOUNT_FILTERS,
  UPDATE_DISCOUNT_FAILURE,
    FETCH_DISCOUNT_APPROVALS_REQUEST,
    FETCH_DISCOUNT_APPROVALS_SUCCESS,
    FETCH_DISCOUNT_APPROVALS_FAILURE,
    APPROVE_DISCOUNT_REQUEST,
    APPROVE_DISCOUNT_SUCCESS,
    APPROVE_DISCOUNT_FAILURE,
    REJECT_DISCOUNT_REQUEST,
    REJECT_DISCOUNT_SUCCESS,
    REJECT_DISCOUNT_FAILURE,
    FETCH_DISCOUNT_HISTORY_REQUEST,
    FETCH_DISCOUNT_HISTORY_SUCCESS,
    FETCH_DISCOUNT_HISTORY_FAILURE,
  UPDATE_DISCOUNT_REQUEST,
  UPDATE_DISCOUNT_SUCCESS,
} from "constants/Discount";

const initialFilters = {
  search: "",
  kind: "ALL",
  approvalStatus: "ALL",
  active: "ALL",
};

const initialState = {
  list: [],
  filters: initialFilters,
  loading: false,
  error: null,
  saving: false,
  deleting: false,
  current: null,
  currentLoading: false,
  couponList: [],
  couponListMeta: null,
  couponListLoading: false,
  couponListError: null,
  generatingCoupons: false,
  printingCoupons: false,
  markingCouponUsed: false,
  lastGeneratedBatch: null,
  approvalList: [],
  approvalLoading: false,
  approvalError: null,
  approvalFilters: { status: "PENDING", kind: "ALL", search: "" },
  approvalActionLoading: false,
  approvalHistory: {},
  approvalHistoryLoading: false,
  approvalHistoryError: null,
};

const discountReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DISCOUNT_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case RESET_DISCOUNT_FILTERS:
      return {
        ...state,
        filters: initialFilters,
      };

    case FETCH_DISCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DISCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: Array.isArray(action.payload)
          ? action.payload
          : Array.isArray(action.payload?.data)
          ? action.payload.data
          : [],
      };

    case FETCH_DISCOUNTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_DISCOUNT_REQUEST:
      return {
        ...state,
        currentLoading: true,
        current: null,
        error: null,
        couponList: [],
        couponListError: null,
      };

    case FETCH_DISCOUNT_SUCCESS:
      return {
        ...state,
        currentLoading: false,
        current: action.payload,
      };

    case FETCH_DISCOUNT_FAILURE:
      return {
        ...state,
        currentLoading: false,
        error: action.payload,
      };

    case CREATE_DISCOUNT_REQUEST:
    case UPDATE_DISCOUNT_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case CREATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        saving: false,
        list: [action.payload, ...state.list],
        current: action.payload,
      };

    case UPDATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        saving: false,
        list: state.list.map((discount) =>
          discount.id === action.payload.id ? action.payload : discount
        ),
        current: action.payload,
      };

    case CREATE_DISCOUNT_FAILURE:
    case UPDATE_DISCOUNT_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload,
      };

    case DELETE_DISCOUNT_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case DELETE_DISCOUNT_SUCCESS:
      return {
        ...state,
        deleting: false,
        list: state.list.filter((discount) => discount.id !== action.payload),
      };

    case DELETE_DISCOUNT_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.payload,
      };

    case FETCH_DISCOUNT_COUPONS_REQUEST:
      return {
        ...state,
        couponListLoading: true,
        couponListError: null,
      };

    case FETCH_DISCOUNT_COUPONS_SUCCESS:
      return {
        ...state,
        couponListLoading: false,
        couponList: Array.isArray(action.payload?.coupons)
          ? action.payload.coupons
          : Array.isArray(action.payload?.data)
          ? action.payload.data
          : [],
        couponListMeta: action.payload?.meta ?? action.payload?.metaData ?? null,
      };

    case FETCH_DISCOUNT_COUPONS_FAILURE:
      return {
        ...state,
        couponListLoading: false,
        couponListError: action.payload,
      };

    case GENERATE_DISCOUNT_COUPONS_REQUEST:
      return {
        ...state,
        generatingCoupons: true,
        couponListError: null,
      };

    case GENERATE_DISCOUNT_COUPONS_SUCCESS:
      return {
        ...state,
        generatingCoupons: false,
        lastGeneratedBatch:
          action.payload?.result?.coupon_name ??
          action.payload?.result?.batch_code ??
          action.payload?.coupon_name ??
          action.payload?.batch_code ??
          null,
      };

    case GENERATE_DISCOUNT_COUPONS_FAILURE:
      return {
        ...state,
        generatingCoupons: false,
        couponListError: action.payload,
      };

    case MARK_DISCOUNT_COUPONS_PRINTED_REQUEST:
      return {
        ...state,
        printingCoupons: true,
      };

    case MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS:
    case MARK_DISCOUNT_COUPONS_PRINTED_FAILURE:
      return {
        ...state,
        printingCoupons: false,
        couponListError: action.type === MARK_DISCOUNT_COUPONS_PRINTED_FAILURE ? action.payload : state.couponListError,
      };

    case MARK_DISCOUNT_COUPONS_USED_REQUEST:
      return {
        ...state,
        markingCouponUsed: true,
      };

    case MARK_DISCOUNT_COUPONS_USED_SUCCESS:
    case MARK_DISCOUNT_COUPONS_USED_FAILURE:
      return {
        ...state,
        markingCouponUsed: false,
        couponListError: action.type === MARK_DISCOUNT_COUPONS_USED_FAILURE ? action.payload : state.couponListError,
      };

    case FETCH_DISCOUNT_APPROVALS_REQUEST:
      return {
        ...state,
        approvalLoading: true,
        approvalError: null,
        approvalFilters: {
          ...state.approvalFilters,
          ...(action.payload || {}),
        },
      };

    case FETCH_DISCOUNT_APPROVALS_SUCCESS:
      return {
        ...state,
        approvalLoading: false,
        approvalList: Array.isArray(action.payload)
          ? action.payload
          : Array.isArray(action.payload?.data)
          ? action.payload.data
          : [],
      };

    case FETCH_DISCOUNT_APPROVALS_FAILURE:
      return {
        ...state,
        approvalLoading: false,
        approvalError: action.payload,
      };

    case APPROVE_DISCOUNT_REQUEST:
    case REJECT_DISCOUNT_REQUEST:
      return {
        ...state,
        approvalActionLoading: true,
        approvalError: null,
      };

    case APPROVE_DISCOUNT_SUCCESS:
    case REJECT_DISCOUNT_SUCCESS:
      return {
        ...state,
        approvalActionLoading: false,
        approvalList: state.approvalList.filter((item) => {
          const removedId =
            action.payload?.id ?? action.payload?.result?.id ?? action.payload?.discount?.id ?? null;
          return item.id !== removedId;
        }),
        current:
          state.current &&
          (state.current.id === (action.payload?.id ?? action.payload?.result?.id ?? action.payload?.discount?.id))
            ? (action.payload?.result ?? action.payload)
            : state.current,
      };

    case APPROVE_DISCOUNT_FAILURE:
    case REJECT_DISCOUNT_FAILURE:
      return {
        ...state,
        approvalActionLoading: false,
        approvalError: action.payload,
      };

    case FETCH_DISCOUNT_HISTORY_REQUEST:
      return {
        ...state,
        approvalHistoryLoading: true,
        approvalHistoryError: null,
      };

    case FETCH_DISCOUNT_HISTORY_SUCCESS:
      return {
        ...state,
        approvalHistoryLoading: false,
        approvalHistory: {
          ...state.approvalHistory,
          [action.payload?.id ?? action.payload?.discount_id]: Array.isArray(action.payload?.items)
            ? action.payload.items
            : Array.isArray(action.payload?.data)
            ? action.payload.data
            : [],
        },
      };

    case FETCH_DISCOUNT_HISTORY_FAILURE:
      return {
        ...state,
        approvalHistoryLoading: false,
        approvalHistoryError: action.payload,
      };

    default:
      return state;
  }
};

export default discountReducer;
